import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AUTH_CONFIG, AuthConfig } from './auth.config';
import { errorInterceptor } from './error.interceptor';
import { tokenCachingInterceptor } from './token-caching.interceptor';
import { tokenRefreshInterceptor } from './token-refresh.interceptor';

/** the auth chain, in request order: refresh first, so the header is minted from a fresh token; error last, closest to the backend */
export const authInterceptors = [tokenRefreshInterceptor, tokenCachingInterceptor, errorInterceptor];

/**
 * Wires the auth stack for one app, HttpClient included: an app calls provideAuth(config) and
 * nothing else for HTTP. The backend is fetch, Angular's default. A spec that needs the testing
 * backend lists provideHttpClientTesting() AFTER provideAuth(), so it wins.
 */
export function provideAuth(config: AuthConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: AUTH_CONFIG, useValue: config },
    provideHttpClient(withInterceptors(authInterceptors)),
  ]);
}
